import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router"
import { Route } from '../../interfaces/route';
import { RouteService } from '../../services/route.service';

@Component({
  selector: 'app-route-header',
  templateUrl: './route-header.component.html',
  styleUrls: ['./route-header.component.css']
})
export class RouteHeaderComponent implements OnInit {

  public route_id: string = "1";
  public routes: Route[] = [];
  public detailed_route: any = { id: '' };
  public realtime: boolean = true;
  

  constructor(private route: ActivatedRoute, private routeService: RouteService) {
    this.route_id = this.route.snapshot.paramMap.get('route');
    this.detailed_route = this.routeService.detailed;
   }

  ngOnInit(): void {
    this.get_routes();
    this.detailed_route.id = this.routeService.detailed.id

    if (this.route_id != null) {
      this.detailed_route = { id: this.route_id };
    }
    else {
      this.detailed_route.id = this.routeService.detailed.id
    }
  }

  get_routes(): void {
    this.routeService.get()
      .subscribe(routes => {
        this.routes = routes;
        this.realtime = this.routeService.realtime;
      });
  }

}
